import Api from '../../../helpers/Api';

// @TODO use setAppParameters here as well
export const ENABLE_TESTS = 'ENABLE_TESTS';
export const enableTests = (enabledTests) => ({
    type: ENABLE_TESTS,
    enabledTests,
});

export const SET_APP_PARAMETERS = 'SET_APP_PARAMETERS';
export const setAppParameters = (appParameters) => ({
    type: SET_APP_PARAMETERS,
    appParameters,
});

export const getAppParameters = () => (dispatch) => {
    const query = 'api/v1/getAppParameters';

    return Api.progressGet(dispatch, query)
        .then((json) => {
            if (json.status !== 'success') {
                throw 'error from server';
            } else {
                dispatch(setAppParameters(json.data));
            }
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
};
